//import Cookies from 'js-cookie'

const TokenKey = 'Authorization'
//const TokenTime = 'TokenTime'
const Company = 'CompanyId'
const History = 'historyArray'

//设置token
export function setToken(token) {
  return localStorage.setItem(TokenKey,token)
 // return Cookies.set(TokenKey,token,{})
}
//获取token
export function getToken() {
  return localStorage.getItem(TokenKey)
}

//删除token
export function removeToken() {
  return localStorage.removeItem(TokenKey)
  //return Cookies.remove(TokenKey)
}

export function setTokenTime(token) {
  localStorage.setItem(TokenKey,token)
 //  var inFifteenMinutes = new Date(new Date().getTime() + 3 * 60 * 1000);
 // return Cookies.set(inFifteenMinutes,token,{expires:7})
}

export function setCompanyId(CompanyId){
  return sessionStorage.setItem(Company,CompanyId)
}

export function getCompanyId(){
  return sessionStorage.getItem(Company)
}

export function getHistory() {
  return localStorage.getItem(History)
}

export function setHistory(historyArray) {
  return localStorage.setItem(History,JSON.stringify(historyArray))
}

export function removeHistory() {
  return localStorage.removeItem(History)
}